import React from 'react';
import FilterContainer from './filters/FilterContainer';
import ListingContainer from './items/ListingContainer';
import { filterItems, paginateItems, sortItems } from './utils/item-filter';
import { getActiveFiltersWithValues } from './utils/active-filters.js';

const FilteredListing = (props) => {

    const activeFilters = getActiveFiltersWithValues(props.activeFilters);
    const filteredItems = filterItems(activeFilters, props.items, props.filterSettings.keywordSearchableFields);
    const sortedItems = sortItems(filteredItems, props.currentSort);
    const pagedItems = paginateItems(sortedItems, props.currentPage, props.itemsPerPage);

    return (
        <div className={`component-filtered-listing ${props.filtersLayout}`}>
            <div className="filtered-listing-container">
                <div className='filter-listing'>
                    <FilterContainer
                        filters = {props.filters}
                        activeFilters = {activeFilters}
                        filterSettings = {props.filterSettings}
                        toggleFilters = {props.toggleFilters}
                        resetFilters = {props.resetFilters}
                        resetFilterGroup = {props.resetFilterGroup}
                        focusedFilter={props.focusedFilter}
                        toggleFocus={props.toggleFocus} />

                    <ListingContainer
                        listItems = {pagedItems}
                        itemCount = {filteredItems.length}
                        totalPages = {Math.ceil(filteredItems.length / props.itemsPerPage)}
                        resources = {props.resources}
                        itemWrapperModifier = {props.itemContainerLayout}
                        itemType = {props.itemType}
                        showResultCount = {props.showResultCount}
                        sortBy = {props.sortBy}
                        currentSort = {props.currentSort}
                        updateSort = {props.updateSort}
                        itemsPerPage = {props.itemsPerPage}
                        currentPage = {props.currentPage}
                        changePage = {props.changePage}
                        resetFilters = {props.resetFilters}/>
                </div>
            </div>
        </div>
    );
};

FilteredListing.propTypes = {
    items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    itemContainerLayout: React.PropTypes.string.isRequired,
    itemType: React.PropTypes.string.isRequired,
    resources: React.PropTypes.arrayOf(React.PropTypes.object),
    filters: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    filterSettings: React.PropTypes.object.isRequired,
    filtersLayout: React.PropTypes.string.isRequired,
    activeFilters: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    toggleFilters: React.PropTypes.func.isRequired,
    resetFilters: React.PropTypes.func.isRequired,
    resetFilterGroup: React.PropTypes.func.isRequired,
    sortBy: React.PropTypes.arrayOf(React.PropTypes.object),
    currentSort: React.PropTypes.object,
    updateSort: React.PropTypes.func.isRequired,
    showResultCount: React.PropTypes.bool,
    currentPage: React.PropTypes.number.isRequired,
    itemsPerPage: React.PropTypes.number.isRequired,
    changePage: React.PropTypes.func.isRequired,
    focusedFilter: React.PropTypes.object,
    toggleFocus: React.PropTypes.func.isRequired
};

export default FilteredListing;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/FilteredListing.jsx
 **/